import './index.scss'
import './dayjsSetup'
import { ConfigProvider } from 'antd'
import zhCN from 'antd/es/locale/zh_CN'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import NiceModal from '@ebay/nice-modal-react'
import reportWebVitals from './reportWebVitals'
import Routes from './routes'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <ConfigProvider
    locale={zhCN}
    theme={{ token: { borderRadius: 2, colorPrimary: '#1890ff' } }}
  >
    <BrowserRouter>
      <NiceModal.Provider>
        <Routes />
      </NiceModal.Provider>
    </BrowserRouter>
  </ConfigProvider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
